










import Vue from 'vue';
import Arrow from '@/components/common/icons/Arrow.vue';

export default Vue.extend({
  name: `ChristmasCalendarButton`,
  components: { Arrow },
  props: {
    label: {
      required: true,
      type: String,
    },
  },
  methods: {
    triggerClick(): void {
      this.$emit(`click`);
    },
  },
});
